import urljoin from "url-join";

export const CMS_URL = process.env.GATSBY_CMS_URL || "http://localhost:8000";
export const GRAPHQL_URL = urljoin(CMS_URL, "graphql");
